module.exports = __webpack_public_path__ + "img/agronomy3.2ad2c61d.png";